import { useState } from 'react';

import { useConfigOfferDateRangeMessage } from 'hooks/loyalty/use-config-offer-date-range-message';
import { useOfferExpiration } from 'hooks/loyalty/use-offer-expiration';
import { useLoyaltyWalmart } from 'pages/loyalty/loyalty-partners/walmart/use-loyalty-walmart';
import { useLoyaltyContext } from 'state/loyalty';
import { getWalmartSeasonalConfigOfferIds } from 'state/loyalty/hooks/utils/walmart';

import { OfferListItemProps } from '../types';

type UseOfferListItemProps = Pick<
  OfferListItemProps,
  | 'id'
  | 'offerApplied'
  | 'offerText'
  | 'handleRemove'
  | 'removeOfferText'
  | 'isWalmartOffer'
  | 'isWalmartUser'
  | 'endDate'
  | 'expirationDate'
>;

export const useOfferListItem = ({
  id,
  offerApplied,
  offerText,
  handleRemove,
  removeOfferText,
  isWalmartOffer,
  isWalmartUser,
  endDate,
  expirationDate,
}: UseOfferListItemProps) => {
  const { data: loyaltyWalmartData } = useLoyaltyWalmart();
  const [isHovered, setIsHovered] = useState(false);
  const { offersCooldown } = useLoyaltyContext();

  const isWalmartSeasonalOffer =
    id && getWalmartSeasonalConfigOfferIds(loyaltyWalmartData).includes(id);

  const expiresAt = useOfferExpiration(
    endDate,
    expirationDate,
    !!(isWalmartOffer || isWalmartSeasonalOffer)
  );

  const configOfferDateRange = useConfigOfferDateRangeMessage(
    (isWalmartSeasonalOffer &&
      loyaltyWalmartData?.seasonalPromoConfig?.configOffers?.find(
        configOffer => configOffer?._id === id
      )) ||
      undefined
  );

  const isVisible = !(
    !offerApplied &&
    (isWalmartOffer || isWalmartSeasonalOffer) &&
    !isWalmartUser
  );

  const showWalmartBadge = isWalmartOffer || isWalmartSeasonalOffer;
  const offerIsApplied = !!(offerApplied && offerText && handleRemove && removeOfferText);
  const walmartBadgeImage = loyaltyWalmartData?.badge?.locale;

  return {
    isHovered,
    setIsHovered,
    offersCooldown,
    expiresAt,
    configOfferDateRange,
    isVisible,
    showWalmartBadge,
    offerIsApplied,
    walmartBadgeImage,
    isWalmartSeasonalOffer,
  };
};
